import React, { Component } from 'react'
import { Icon } from 'antd'
import _ from 'lodash'
export default class Detail extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }

    render() {
        const { open } = this.state
        const { drug_key, drug } = this.props
        const { price, discount_price, discount, quantity, description } = drug

        return (
            <div style={{ cursor: 'pointer' }}>
                <div
                    style={{ textDecoration: 'underline', paddingBottom: '1rem' }}
                    onClick={() => this.toggleVisibility()}
                >
                    <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                    <strong> {drug_key} </strong>
                </div>
                <div
                    style={{
                        display: `${this.state.open ? 'flex' : 'none'}`,
                        paddingRight: '1.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <div>
                        {price && (
                            <div>
                                <strong>מחיר : </strong>
                                {price}
                            </div>
                        )}
                        {discount_price && (
                            <div>
                                <strong>מחיר מוזל : </strong>
                                {discount_price}
                            </div>
                        )}
                        {discount && (
                            <div>
                                <strong>הנחה : </strong>
                                {discount}
                            </div>
                        )}
                        {quantity && (
                            <div>
                                <strong>כמות : </strong>
                                {quantity}
                            </div>
                        )}
                        {description && (
                            <div>
                                <strong>תיאור : </strong>
                                {description}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
